angular.module('component-payments.validate.name', [])
	.directive('ctPaymentsValidateName', paymentsValidateNameDirective);

function paymentsValidateNameDirective() {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: postLink
	};

	function postLink(scope, element, attrs, ctrl) {
		ctrl.$validators.shortName = function (modelValue, viewValue) {
			var value = modelValue || viewValue || '',
				isShort = value.length < 4;

			if (!value)
				return true;

			return !isShort;
		};
	}
}

module.exports = 'component-payments.validate.name';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/validators/name.js
 ** module id = 101
 ** module chunks = 1
 **/